import api from '@/plugins/request/index';

// 获取公众号扫码登录地址
export const getWechatOfficialImg = async (type = 'get') => {
  return api[type]('/gateway/v1/wechat/login/qrcode').then(res => res);
}
// 获取公众号登录状态
export const getWechatOfficialLogin = async (params, type = 'post') => {
  return api[type]('/gateway/v1/wechat/login', params).then(res => res);
}
// 公众号绑定经纪人
export const wechatBindAgent = async (params, type = 'post') => {
  return api[type]('/gateway/v1/wechat/login/bind', params).then(res => res);
}
// 账号密码
export const loginByAccount = async (params, type = 'post') => {
  return api[type](`/gateway/v1/login`, params).then(res => res);
}
// 获取可选择的商户
export const getCompanyList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/login-company-list`, params).then(res => res);
}
// 选择商户进行登录
export const loginByCompany = async (params, type = 'post') => {
  return api[type](`/gateway/v1/login-with-company-id`, params).then(res => res);
}
// 发送重置验证码
export const sendResetCode = async (params, type = 'post') => {
  return api[type](`/gateway/v1/send-reset-sms`, params).then(res => res);
}
// 重置密码
export const resetPassword = async (params, type = 'put') => {
  return api[type](`/gateway/v1/reset-pwd-with-sms`, params).then(res => res);
}
// 获取第三方登录跳转url
export const getThreeLoginUrl = async (type = 'get') => {
  return api[type](`/gateway/v1/we_work/third/login-url`).then(res => res);
}